module.exports = __webpack_public_path__ + "static/img/trust-1-1.62ce78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/trust-1-1.png
// module id = 627C
// module chunks = 1